import { useContext } from 'react';
import { FeatureContext } from 'FeatureProvider/FeatureContext';
import { getSessionUseCases } from '@subscriptions/composition';

export const SUBSCRIPTIONS_READ_ONLY_FLAG = 'ffSubscriptionsReadOnlyOrganizations';

type FeatureContextValue = { flags?: Record<string, unknown> } | null;

/**
 * True when the current organization appears in the `ffSubscriptionsReadOnlyOrganizations` remote
 * flag (`{ "organizationUuidList": [...] }`), which leaves the subscription views read-only.
 *
 * A missing provider or a missing or malformed flag locks nothing: the flag only takes actions away,
 * so failing open keeps the views usable. The session is read only once the flag lists someone.
 */
export const useAreSubscriptionActionsLocked = (): boolean => {
  const features = useContext(FeatureContext) as FeatureContextValue;
  const flag = features?.flags?.[SUBSCRIPTIONS_READ_ONLY_FLAG];

  if (!flag || typeof flag !== 'object') return false;

  const { organizationUuidList } = flag as { organizationUuidList?: unknown };

  if (!Array.isArray(organizationUuidList) || organizationUuidList.length === 0) return false;

  const organizationUuid = getSessionUseCases().getCurrentOrganizationUuid.execute();

  return Boolean(organizationUuid) && organizationUuidList.includes(organizationUuid);
};
